<template>
  <div>
    <title>兑换礼品券</title>
    <section class="goodsBox">
      <!--S 检索-->
      <el-form :model="searchGLForm" inline class="serGlForm">
        <el-form-item label="关键词"><el-input v-model="searchGLForm.keyword" placeholder="请输入内容" clearable></el-input></el-form-item>
        <el-form-item  label="商品分类">
          <!-- 商品分类下拉组件 -->
          <GoodsClassSelect :classInfo="{oneCode:searchGLForm.categorycode,twoCode:searchGLForm.tcategorycode}" @classObtain="calssReceive"></GoodsClassSelect>
          <!-- 商品分类下拉组件 -->
        </el-form-item>
        <!-- S 商品上下架组件 -->
        <GoodsBsale :bsale="searchGLForm.bsale" @goodsBsaleObtain="goodsBsaleReceive"></GoodsBsale>
        <!-- E 商品上下架组件 -->
        <el-form-item>
          <el-button type="primary" @click="querySubmit">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"  plain :loading="exploading" @click="expdaochu">导出</el-button>
        </el-form-item>
        <el-form-item v-show="!goodsStatus && !riskStatus">
          <el-button type="primary" plain @click="goBasicInfo">新增商品</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" plain v-show="!goodsStatus && !riskStatus" @click="groupUpper(1)">批量上架</el-button>
          <el-button type="primary" plain v-show="!goodsStatus && !riskStatus" @click="groupUpper(0)">批量下架</el-button>
          <el-button type="danger" v-show="goodsStatus" icon="el-icon-close" round @click="confirmCancel(0)">取消</el-button>
          <el-button type="success" v-show="goodsStatus" icon="el-icon-check" round @click="confirmCancel(1)">确定</el-button>
        </el-form-item>
        
      </el-form>
      <!--E 检索-->
      <div class="gsListTable individualiz" v-loading="loading">
        <el-form :model="searchGLForm" inline size="medium">
          <el-form-item class="borderline">
            <em class="redColor fwBold">商品用途</em>
            <el-checkbox-group v-model="searchGLForm.usefor" @change="querySubmit">
              <el-checkbox v-for="(item,index) in useforLists" :label="item.value" :key="index">{{item.label}}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-form>
        <!--S 商品列表-->
        <el-table ref="gsTable" class="gsTable comTable" border :data="goodsList" :maxHeight="tableHeight" @selection-change="handleSelectionChange">
          <el-table-column v-if="goodsStatus || riskStatus" type="selection" width="100" :selectable="selectTrue"></el-table-column>
          <el-table-column type="index" label="序号"></el-table-column>
          <el-table-column label="商品分类" min-width="300">
            <template slot-scope="scope">
              <p class="textFl" :title="scope.row.categoryname">{{scope.row.categoryname}}</p>
              <small class="textFl" :title="scope.row.tcategoryname" v-if="bopentclassify == 1">{{scope.row.tcategoryname}}</small>
            </template>
          </el-table-column>
          <el-table-column label="商品内容" prop="goodsname" sortable min-width="400">
            <template slot-scope="scope">
              <section class="flexAro pdr70">
                <span class="goodsImg"><img width="80px" :src="scope.row.kindpic?scope.row.kindpic:(scope.row.maingoodspic?scope.row.maingoodspic:'')" onerror="this.src='https://presale.jhtsoft.com/picms/c47499b67d489.png'" /></span>
                <div class="goodsCont">
                  <h3 :title="scope.row.goodsname">{{scope.row.goodsname}}</h3>
                  <p :title="scope.row.kindinfo">{{scope.row.kindinfo}}</p>
                  <dl>
                    <dt class="priceFont" v-if="scope.row.kindcode"><i>￥</i>{{scope.row.cardcategory===2?scope.row.goodsprice:scope.row.goodsmallprice | formatAmount}}</dt>
                    <dd>
                      <el-tag v-if="scope.row.usefor.indexOf('2')!=-1" type="danger" effect="dark" title="商城销售">售</el-tag>
                      <span class="iconminpragram minProgramTip" v-if="ElementControls('OpenMiniProgram') == 1 &&scope.row.usefor.indexOf('4')!=-1" title="小程序商城"></span>
                    </dd>
                  </dl>
                </div>
              </section>
            </template>
          </el-table-column>
          <el-table-column label="上/下架" prop="bsale" sortable min-width="200">
            <template slot-scope="scope" v-if="scope.row.kindcode&&scope.row.kindcode!=null">
              <el-switch :value="scope.row.bsale?true:false" @change="switchChange(scope.row)" :width="55" class="isSwitch" :active-text="scope.row.bsale?'上架':'下架'"></el-switch>
              <small>录入时间：{{dateTime(scope.row.credate,1)}}</small>
              <small v-if="scope.row.credate!=scope.row.upddate">修改时间：{{dateTime(scope.row.upddate,1)}}</small>
            </template>
          </el-table-column>
          <!-- <el-table-column label="操作" >
            <template slot-scope="scope">
                <div class="handle">
                  <span title="商品管理" @click="goodsMange(scope.row.goodscode)">商品管理</span>
                  <span title="规格管理" @click="kindinfoMange(scope.row)">规格管理</span>
                  <span title="删除" @click="deleteGoods(scope.row.goodscode)">删除</span>
                </div>
            </template>
          </el-table-column> -->
          <el-table-column label="操作" fixed="right" width="150">
            <template slot-scope="scope">
              <el-dropdown trigger="click" @command="handleCommand" placement="bottom-start">
                <span class="el-dropdown-link">
                  全部操作<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="{type:'goodsMange',info:scope.row}">商品管理</el-dropdown-item>
                  <el-dropdown-item :command="{type:'kindinfoMange',info:scope.row}">规格管理</el-dropdown-item>
                  <el-dropdown-item :command="{type:'deleteGoods',info:scope.row}">删除</el-dropdown-item>
                  <el-dropdown-item :command="{type:'getLinks',info:scope.row}" v-if="scope.row.kindcode&&!scope.row.isgift&&scope.row.usefor.indexOf('2')!=-1">获取链接</el-dropdown-item>
                  <!-- <el-dropdown-item :command="{type:'copyCreate',info:scope.row}" v-if="ElementControls('jinshizun')!=1">一键复制商品</el-dropdown-item> -->
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>

          <template slot="empty">
            <div class="noData"><span>暂无数据</span></div>
          </template>
        </el-table>
        <!--E 商品列表-->
      </div>
      <!-- S 分页 -->
      <Page :pageTotal="pagebBean.totalnum" :currentPage="currentPage" @nowPageParam="updatePage"></Page>
      <!-- S 分页 -->
    </section>

    <!-- S 规格管理弹窗 -->
    <KindAdminister :goodsType="1" :specMange="specMange" @closeKindPop="closeKindPope"></KindAdminister>
    <!-- E 规格管理弹窗 -->

    <!--S 下架备注组件-->
    <LowerMemo :lowerMemoBox="lowerPopShow" :goodsLower="goodsLower" :muitiBath="muitiBath" :operateUpper="operateUpper" :goodsType="1" @closeLMemoBox="closeLowerMemo"></LowerMemo>
    <!--E 下架备注组件-->
    <!--S 获取链接组件-->
    <CopyLink :linkDetailBox="linkDetail" :linkTitle="linkTitle" :doubleLink="doubleLink" :copyInfo="goodsInfo" @closeLinkBox="linkDetail = false"></CopyLink>
    <!--E 获取链接组件-->

    <!-- S 批量改分类组件 -->
    <categroyMange :categroyMangeBox="categroyMangeShow" :sourceType="0" :goodsType="1" @closeCategroyBox="closeCategroyBox"></categroyMange>
    <!-- E 批量改分类组件 -->
    <!-- S 控价设置弹窗 -->
    <Riskcontrol :riskcontrolShow="riskcontrolShow" :goodsInfo="riskType==1?goodsInfo:''" @closeCld="getCloseRiskDlog" :isBatch="isBatch"></Riskcontrol>
    <!-- E 控价设置弹窗 -->
    <!--S 一键复制创建商品弹窗-->
    <AutoCreateGoods :autoCreateShow="autoCreateShow" :goodsInfo="goodsInfo" @closeChild="handleCloseAutoCreate"
      v-if="autoCreateShow"></AutoCreateGoods>
    <!--E 一键复制创建商品弹窗-->

  </div>
</template>
<script>
import { MessageBox } from "element-ui";
import api from '../../../apis/api.js'
export default {
  name:'GoodsList',
  data () {
    return {
      exploading:false,
      linkDetail:false,//获取链接弹框
      linkTitle:'访问链接：',//链接标题
      doubleLink:true,//双链接
      goodsLower:true,
      goodsType: 3, // 商品类型
      goodsInfo: '', // 操作的商品信息
      cardType: '', // 兑换礼券/消费卡 支持的卡类型
      loading: true, // 加载中弹窗显示和隐藏
      useforLists:[ //商品用途 0：预售；1：溯源；2：营销（复选项，中间以#隔开this.usefor.join('#')）
        {label:'商城销售',value:'2'}
      ],
      selclsLists:[ //销售类型 0：实体券；1：电子券；
        {label:'实体券',value:'0'},
        {label:'电子券',value:'1'}
      ],
      supplyLists:[
        {label:'作为赠品',value:'isgift'},
        {label:'包邮',value:'freeshipping'},
      ],
      searchGLForm:{
        keyword:'',//关键词
        band:'',//预售品牌
        categorycode:'', //选中分类编号        
        tcategorycode:'', //选中二级分类编号
        bsale: '1', //是否上架
        usefor: [], // 商品用途。0：预售；1：溯源；2：营销（复选项，中间以#隔开this.usefor.join('#')）
        selcls: [],//销售类型。0：实体券；1：电子券
        supplyfor:[], //作为什么使用supplyLists
        isgift:'',//是否作为赠品
        postagefree:'',//是否包邮
        salesbarcode: '', // 销售条码
        sort: '', // 排序检索 showpos按升序
        shippercode: '', // 发货方编号
        cardcategory:false,//按量提货卡
        tcCardcategory:false,
        deCardcategory:false,
      },
      pageSize: 30, // 每页展示的条数
      currentPage: 1, // 当前请求的页数
      pagebBean: {
          totalnum: 0,
      }, // 获取到的列表分页信息
      goodsList: [], // 获取到的商品列表
      goodsStatus:false, //批量上架状态
      operateUpper:null, //批量上下架操作
      multipleSelection: [], //已选中的行
      bsaleCodes: '', // 上下架操作的商品规格编号
      lowerPopShow:false, //下架备注弹窗
      lowerMemo: '', // 下架备注
      tableHeight: window.innerHeight*.8, //表格动态高度
      specMange:false,
      categroyMangeShow:false, //批量改分类
      firstTrue: true, // 防止多次点击提交
      bopentclassify: 0, // 是否开通二级分类
      riskcontrolShow:false,//控价设置弹窗
      riskStatus:false,//批量控价状态
      riskType: 0, // 操作控价的类型 0为批量 1为单独
      isBatch:false,//是否是批量控价设置，默认false
      patchName: '', // 来源路由路径name
      operateType: 0, // 操作的类型 0为新增 1为编辑
      autoCreateShow: false,//一键复制新增弹窗
      muitiBath:0,//是否是批量操作
    }
  },
  filters: {

  },
  components: {
    Page: resolve => require(["@/components/common/Page.vue"], resolve),
    LowerMemo: resolve => require(["@/components/GoodsFolder/LowerMemo.vue"], resolve), //下架备注组件
    GoodsClassSelect: resolve => require(["@/components/common/GoodsClassSelect.vue"], resolve), // 商品分类下拉组件
    GoodsBsale: resolve => require(["@/components/Gadget/GoodsBsale.vue"], resolve), // 上下架下拉组件
    KindAdminister: resolve => require(["@/components/GoodsFolder/KindAdminister.vue"], resolve), // 规格管理商品弹窗
    PresaleBrandSelect: resolve => require(["@/components/common/PresaleBrandSelect.vue"], resolve), // 预售品牌下拉弹窗组件
    CopyLink: resolve => require(["@/components/common/CopyLink.vue"], resolve), //获取链接组件
    categroyMange: resolve => require(["@/components/GoodsFolder/categroyMange.vue"], resolve), //批量修改分类组件
    Riskcontrol: resolve => require(["@/components/GoodsFolder/Riskcontrol.vue"], resolve),//控价属性
    FlowSelectPage: resolve => require(["@/components/common/FlowSelectPage.vue"], resolve), // 发货方下拉组件 带分页
    AutoCreateGoods: resolve => require(["@/components/GoodsFolder/AutoCreateGoods.vue"], resolve),//一键复制新建商品信息
  },
  // ============================================== 监听 ==============================================
  watch: {
    'searchGLForm.sort'(val) {
      // 查询确定事件
      this.querySubmit();
    },
    '$route'(to,from) {
      this.patchName = from.name;
    }
  },
  // ============================================== 方法 ==============================================
  methods: {
    // 关闭一键复制创建商品信息弹框
    handleCloseAutoCreate(val) {
      if (val == 1) {
        // 清空检索条件
        this.querySubmit();
      }
      this.autoCreateShow = false;
    },
    changecardcategory(){
          this.searchGLForm.tcCardcategory = false
          this.searchGLForm.deCardcategory = false
          this.querySubmit();
        },
        changetcCardcategory(){
            this.searchGLForm.cardcategory = false
            this.searchGLForm.deCardcategory = false
            this.querySubmit();
        },
        changedeCardcategory(){
            this.searchGLForm.cardcategory = false
            this.searchGLForm.tcCardcategory = false
            this.querySubmit();
        },
    //关闭批量修改分类弹窗
    closeCategroyBox(type){
      if(type == 1) {
        this.querySubmit();
      };
      this.categroyMangeShow = false;
    },
     //导出
     expdaochu(){
      let Param = {
        keyword: this.searchGLForm.keyword, // 关键字
        goodssource: 0, // 商品来源
        catetype: this.goodsType, // 商品类型
        besale: this.cardType, // 卡类型
        brandcode: this.searchGLForm.band, // 品牌编号
        categorycode: this.searchGLForm.categorycode, // 商品分类编号
        tcategorycode: this.searchGLForm.tcategorycode, // 二级商品分类编号
        bsale: this.searchGLForm.bsale!==''?this.searchGLForm.bsale:null, // 上下架
        isgift: this.searchGLForm.supplyfor.indexOf('isgift')!=-1?1:null, // 是否为赠品
        postagefree: this.searchGLForm.supplyfor.indexOf('freeshipping')!=-1?1:null, // 是否包邮
        usefor: this.searchGLForm.usefor[0]?this.searchGLForm.usefor[0]:null, // 商品用途
        salesbarcode: this.searchGLForm.salesbarcode, // 销售条码
        // cardgoods: true, // 是否只获取有规格商品
        sort: this.searchGLForm.sort?'showpos':null,  // 排序检索
        shippercode: this.searchGLForm.shippercode, // 发货方
        cardcategory:this.searchGLForm.cardcategory?0:this.searchGLForm.tcCardcategory?1:this.searchGLForm.deCardcategory?2:'',//是否是按量提货卡
      };
      this.exploading = true;
      api.GET_EXPORTGOODS(Param).then(res =>{
          if(res.data.status=="200"){
            this.exploading = false;
            window.location.href = res.data.data
            this.$message.success(res.data.message)
          }else{
            this.exploading = false;
            this.$message.error(res.data.message)
          }
      }).catch((err)=>{
        this.exploading = false;
      })
    },
    // 获取商品列表数据
    getGoodsList() {
      this.loading = true;
      let goodsParam = {
        keyword: this.searchGLForm.keyword, // 关键字
        goodssource: 0, // 商品来源
        catetype: this.goodsType, // 商品类型
        besale: this.cardType, // 卡类型
        brandcode: this.searchGLForm.band, // 品牌编号
        categorycode: this.searchGLForm.categorycode, // 商品分类编号
        tcategorycode: this.searchGLForm.tcategorycode, // 二级商品分类编号
        bsale: this.searchGLForm.bsale!==''?this.searchGLForm.bsale:null, // 上下架
        isgift: this.searchGLForm.supplyfor.indexOf('isgift')!=-1?1:null, // 是否为赠品
        postagefree: this.searchGLForm.supplyfor.indexOf('freeshipping')!=-1?1:null, // 是否包邮
        usefor: this.searchGLForm.usefor[0]?this.searchGLForm.usefor[0]:null, // 商品用途
        salesbarcode: this.searchGLForm.salesbarcode, // 销售条码
        // cardgoods: true, // 是否只获取有规格商品
        sort: this.searchGLForm.sort?'showpos':null,  // 排序检索
        shippercode: this.searchGLForm.shippercode, // 发货方
        cardcategory:this.searchGLForm.cardcategory?0:this.searchGLForm.tcCardcategory?1:this.searchGLForm.deCardcategory?2:'',
        pageparam: {
          pagesize: this.pageSize, //每页条数
          currentpage: this.currentPage, //当前页数
          isnewcomp: 1 //是否需要重新统计页数
        }
      };
      api.GET_GOODSLIST(goodsParam).then(res => {
        this.toTableTop('gsTable');
        if(res.data.status == "200") {
          this.goodsList = res.data.data;
          this.pagebBean = res.data.pagebean;
        }else {
          this.$message({
            type: 'error',
            message: res.data.message
          })
        }
        this.loading = false;
      })
    },
    // 选检索的销售类型
    purposeUpdate(val) {
      if(val.length == 0) {
        this.cardType = '';
      } else if(val.length == 1){
        if(val.indexOf('0')!=-1) {
          this.cardType = 0;
        }else {
          this.cardType = 2;
        }
      }else {
        this.cardType = 1;
      }
      this.querySubmit()
    },
    // 查询确定事件
    querySubmit(val) {
      this.currentPage = 1;
      this.getGoodsList();
    },
    // 接收分页信息
    updatePage(size,num) {
      this.pageSize = size;
      this.currentPage = num;
      this.goodsStatus = false;
      this.riskStatus = false;
      this.getGoodsList();
    },
    // 判断多选框是否可以选择方法
    selectTrue(val) {
      if(this.riskStatus) {
        if(val.kindcode) {
          return true;
        }else {
          return false;
        }
      } else {
        if((val.bsale == 0&&this.operateUpper == 1)||(val.bsale == 1&&this.operateUpper == 0)) {
          return true;
        }else {
          return false;
        }
      }
    },
    //单独上下架
    switchChange(val){
      this.muitiBath = 0;
      this.bsaleCodes = val.kindcode;
      if(val.bsale == 0) {
        this.operateUpper = 1;
        MessageBox.confirm('确定上架该商品吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.batchUpdStatus();
        }).catch(() => {});
      } else {
        this.operateUpper =0;
        this.lowerPopShow = true; //下架备注弹窗
      }
    },
    //确定/取消批量上下架
    confirmCancel(val){
      if(val==1) {
        if(this.multipleSelection.length > 0) {
          this.bsaleCodes = '';
          this.multipleSelection.forEach(item => {
            if(!this.bsaleCodes) {
              this.bsaleCodes = item.kindcode;
            }else {
              this.bsaleCodes = this.bsaleCodes + ',' + item.kindcode;
            }
          });
          if(this.operateUpper == 1) { // 上架操作
            MessageBox.confirm('确定上架勾选商品吗?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.batchUpdStatus();
            }).catch(() => {});
          } else { // 下架弹窗显示
            this.lowerPopShow = true;
          }
        } else {
           MessageBox.alert('请至少勾选一项！', '系统提示', {
              confirmButtonText: '确定',
              type:'warning'
            }).then(() => {}).catch(() => {});
        }
      }else {
        this.goodsStatus = false;
        this.$refs.gsTable.clearSelection(); // 清空选中列表数据
      }
    },
    //确定下架备注
    closeLowerMemo(val){
      console.log(val)
      this.lowerPopShow = false; //弹窗
      if(val!=='' && val!==undefined) {
        this.lowerMemo = val;
        this.batchUpdStatus();
      }
    },
    // 上下架提交接口
    batchUpdStatus() {
      let bsaleParams = {
        bsale: Number(this.operateUpper),
        codetype: 1,
        codes: this.bsaleCodes,
      }
      if(this.operateUpper!=1) {
        bsaleParams.unshelvememo = this.lowerMemo.unshelvememo;
        bsaleParams.type = this.lowerMemo.bdirectsales;
      }
      api.BATCHUPDSTATUS(bsaleParams).then(res => {
        if(res.data.status == "200") {
          this.$message({
            type: 'success',
            message: res.data.message
          });
          this.goodsStatus = false;
          this.$refs.gsTable.clearSelection(); // 清空选中列表数据
          this.getGoodsList();
        } else {
          this.$message({
            type: 'error',
            message: res.data.message
          });
        }
      })
    },
    // 预售品牌下拉选择值
    brandReceive(val) {
      this.searchGLForm.band = val;
    },
    //下拉框取值
    calssReceive(value) {
      if(value.length>0) {
        if(value.length ==2) {
          this.searchGLForm.categorycode = value[0];
          this.searchGLForm.tcategorycode = value[1];
        } else {
          this.searchGLForm.categorycode = value[0];
        }
      } else {
        this.searchGLForm.categorycode = '';
        this.searchGLForm.tcategorycode = '';
      }
    },
    // 上下架下拉选择值
    goodsBsaleReceive(val) {
      this.searchGLForm.bsale = val;
    },
    // 发货方下拉取值
    flowObtain(val) {
      this.searchGLForm.shippercode = val;
    },
    // 删除商品方法
    deleteGoods(code) {
      if(this.firstTrue) {
         MessageBox.confirm('确定删除该商品吗？此商品下的规格也将一并删除！', '确认提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          let delParams = {
            catetype: this.goodsType,
            gtype: 0,
            code: code
          };
          this.firstTrue = false;
          api.DELETEGOODS(delParams).then(res => {
            if(res.data.status == "200") {
              this.$message({
                type: 'success',
                message: res.data.message
              });
              this.querySubmit();
            }else {
              this.$message({
                type: 'error',
                message: res.data.message
              });
            }
            this.firstTrue = true;
          }).catch(res => {
            this.firstTrue = true;
          })
        }).catch(() => {});  
      }
    },
    // 关闭管理规格选择弹窗
    closeKindPope(type) {
      this.operateType = type;
      this.specMange = false;
    },
    //表格多选选中行复制
    handleSelectionChange(val) { 
      this.multipleSelection = val;
    },
    //批量上下架
    groupUpper(val){
      this.muitiBath = 1;
      this.operateUpper = val;
      this.goodsStatus = true;
    },
    //新增商品
    goBasicInfo(){
      this.operateType = 0;
      this.$router.push({
        path: '/TravelBasicInfo/*?operateTrue=1'
      });
    },
    // // 跳转到商品管理
    // goodsMange(code){ //商品管理
    //   this.$router.push({
    //     name:'兑换礼券基本信息',
    //     params: {
    //       goodscode: code
    //     }
    //   })
    // },
    // // 跳转到规格管理
    // kindinfoMange(info){//规则管理
    //   this.$router.push({
    //     name:'兑换礼券规格管理',
    //     params: {
    //       goodscode: info.goodscode
    //     },
    //     query: {
    //       kindcode: info.kindcode
    //     }
    //   })
    // },

    //操作指令
    handleCommand(command) {
      this.goodsInfo = command.info; // 操作的商品信息
      this.operKindCode = command.info.kindcode; // 操作商品的规格编号
      this.operGoodsCode = command.info.goodscode; // 操作商品的商品编号
      if(command.type == 'goodsMange'){ //商品管理
        this.operateType = 1;
        this.$router.push({
          name:'酒旅产品基本信息',
          params: {
            goodscode: this.operGoodsCode
          },
          query: {
            operateTrue: 1
          }
        })
      }else if(command.type == 'kindinfoMange'){ //规格管理
        this.operateType = 1;
        this.$router.push({
          name:'酒旅产品规格管理',
          params: {
            goodscode: this.operGoodsCode
          },
          query: {
            kindcode: this.operKindCode,
            operateTrue: 1
          }
        })
      }else if(command.type == 'deleteGoods'){ // 删除商品
        this.deleteGoods(this.operGoodsCode);
      }else if(command.type == 'getLinks'){ //获取链接
        this.getLinks();
      }else if(command.type == 'membertype'){//控价设置
        this.riskType = 1;
        this.isBatch = true;
        this.riskcontrolShow = true;
      } else if (command.type == 'copyCreate') { // 一键复制商品弹窗
          this.autoCreateShow = true;
        }
    },
    //获取链接
    getLinks(){
      this.linkDetail = true;
    },
    //批量控价
    groupRisk(val){
      this.riskStatus = true;
    },
    //确定/取消批量控价
    riskCancel(val){
      if(val==1) {
        this.operKindCode = '';
        if(this.multipleSelection.length > 0) {
          this.riskType = 0;
          this.isBatch = false;
          this.riskcontrolShow = true;
          this.multipleSelection.forEach(item => {
            if(!this.operKindCode) {
              this.operKindCode = item.kindcode;
            }else {
              this.operKindCode = this.operKindCode + ',' + item.kindcode;
            }
          });
        } else {
           MessageBox.alert('请至少勾选一项！', '系统提示', {
              confirmButtonText: '确定',
              type: 'warning'
            }).then(() => {}).catch(() => {});
        }
      }else {
        this.riskStatus = false;
        this.$refs.gsTable.clearSelection(); // 清空选中列表数据
      }
    },
    // 关闭控价设置弹窗
    getCloseRiskDlog(info){
      if(info) {
        if(this.firstTrue) {
          let batchParams = {
            kindcodes: this.operKindCode,
            directprice: info.directprice,
            channelprice: info.channelprice,
          }
          this.firstTrue = false;
          api.BATCHSETGOODSCONTROLPRICE(batchParams).then(res => {
            if(res.data.status == "200") {
              this.$message({
                type: 'success',
                message: res.data.message
              })
              this.getGoodsList();
              this.riskcontrolShow = false;
              this.riskStatus = false;
              this.$refs.gsTable.clearSelection(); // 清空选中列表数据
              setTimeout(() => {
                this.firstTrue = true;
              }, 10);
            } else {
              this.$message({
                type: 'error',
                message: res.data.message
              })
            }
            this.firstTrue = true;
          }).catch(res => {
            this.firstTrue = true;
          })
        }
      } else {
        this.riskcontrolShow = false;
        this.riskStatus = false;
        this.$refs.gsTable.clearSelection(); // 清空选中列表数据
      }
    },
    //动态获取表格高度
    getHeight() {
      let tbHeight = this.$refs.gsTable.$el.offsetTop; //顶部检索条件占据的高度
      //console.log('表格距离顶部高度',tbHeight,'可视区高度',window.innerHeight)
      this.tableHeight = window.innerHeight - tbHeight - 130; 
    },
  },
  created() {
    //页面浏览器视窗变化绑定resize事件
    window.addEventListener("resize", this.getHeight);
  },
  mounted () {
    // 获取公共服务基础配置
    if(localStorage.getItem('pubconfiginfo')&&localStorage.getItem('pubconfiginfo')!='null'&&localStorage.getItem('pubconfiginfo')!=undefined) {
      let pubConfigInfo = JSON.parse(localStorage.getItem('pubconfiginfo'))
      this.bopentclassify = pubConfigInfo.bopentclassify;
    }
    if(this.ElementControls('OpenMiniProgram') == 1) {
      this.useforLists.push({
          label:'小程序商城',value:'4'
      })
    }
    // 获取商品列表数据
    this.getGoodsList();
    //在dom渲染之后
    setTimeout(()=>{
      this.getHeight();
    },1000)

  },
  computed: {},
  destroyed(){ 
    window.removeEventListener('resize', this.getHeight); //销毁监听浏览器视窗变化
  },
  activated() {
    if(this.patchName == '兑换礼券基本信息' || this.patchName == '兑换礼券规格管理') {
      if(this.operateType!=1 || sessionStorage.getItem('addSpecify')=='1') {
        sessionStorage.setItem('addSpecify','')
        Object.assign(this.$data, this.$options.data());
        // 获取公共服务基础配置
        if(localStorage.getItem('pubconfiginfo')&&localStorage.getItem('pubconfiginfo')!='null'&&localStorage.getItem('pubconfiginfo')!=undefined) {
          let pubConfigInfo = JSON.parse(localStorage.getItem('pubconfiginfo'))
          this.bopentclassify = pubConfigInfo.bopentclassify;
        }
        // 获取商品列表数据
        this.getGoodsList();
        //在dom渲染之后
        setTimeout(()=>{
          this.getHeight();
        },1000)
        return false;
      } else {
        this.getGoodsList();
      }
    } else{
      sessionStorage.setItem('addSpecify','')
      if(this.patchName) {
        Object.assign(this.$data, this.$options.data());
        // 获取公共服务基础配置
        if(localStorage.getItem('pubconfiginfo')&&localStorage.getItem('pubconfiginfo')!='null'&&localStorage.getItem('pubconfiginfo')!=undefined) {
          let pubConfigInfo = JSON.parse(localStorage.getItem('pubconfiginfo'))
          this.bopentclassify = pubConfigInfo.bopentclassify;
        }
        // 获取商品列表数据
        this.getGoodsList();
        //在dom渲染之后
        setTimeout(()=>{
          this.getHeight();
        },1000)
      }
    }
  },
}
</script>
<style scoped>
@import '../Css/style.css';
.handle span{color: var(--main-color);}
.handle span:hover{opacity: .7; cursor: pointer;}
.goodsBox {padding:20px; height:calc(100% - 40px);}
.gsTable >>> .el-table__header .el-form-item {margin-bottom:0!important;}
.gsTable.el-table >>> thead.is-group > tr:first-child th .cell{overflow: visible!important;}
.gsTable.el-table >>> thead.is-group > tr:nth-child(2) th .cell {color:#333;}

.gsTable.el-table >>> .el-table__body .el-checkbox {padding:20px;}
.gsTable.el-table >>> .el-table__header .el-checkbox {padding:0 20px;}
.gsTable >>> .el-dropdown-link {cursor: pointer; color: var(--main-color);}
.riskPrice{line-height: 1.5;font-size: 14px;font-weight: normal;}
.riskPrice em{font-size: 16px;margin-right: 5px;}
.riskPrice i{color: #FA2F2F;}
</style>



// WEBPACK FOOTER //
// src/views/GoodsFolder/Travel/TravelList.vue